export default () => ({
	event: 'cartRequest'
});
